import {z} from 'zod';

export default z.object({
    fill: z.boolean(),
    caption: z.string().optional(),
    alt: z.string().optional(),
    // per-usage credit override; falls back to image.source / image.source_url
    source: z.string().optional(),
    source_url: z.string().optional(),
    link: z.object({
        href: z.string().optional(),
        target: z.string().optional(),
        rel: z.string().optional(),
    }).optional(),
    image: z.object({
        url: z.string(),
        content_hash: z.string().optional(),
        crop: z.any(),
        origin_height: z.number().optional(),
        origin_width: z.number().optional(),
        // media-level credit, refreshed from the media table on every save
        source: z.string().nullable().optional(),
        source_url: z.string().nullable().optional(),
    }),
});
